import Link from '@/components/link-component.js'
import { smoothScroll } from '@/utils/dom.ts'
import { cx, slugify } from '@/utils/strings.js'
export type SizeType = 'h2' | 'h3'

export default function HeadingWithAnchor({
  id,
  type,
  title,
  className,
}: Readonly<{
  id?: string
  type: SizeType
  title: string
  className?: string
}>) {
  const anchor = slugify(id ?? title)
  return (
    <div id={anchor} className={cx(`scrollspy group inline-block w-full relative`)}>
      <Heading type={type} className={className}>
        <Link
          title={`#${anchor}`}
          to={`#${anchor}`}
          onClick={(event) => {
            const { origin, pathname } = window.location
            navigator.clipboard.writeText(`${origin}${pathname}#${anchor}`)
            smoothScroll(event)
          }}
          className={cx(
            'absolute text-primaryBlue opacity-0 group-hover:opacity-40 hover:opacity-100 transition-opacity duration-150 -left-[1.1em] text-[.73em]'
          )}
        >
          <span className="font-bwi">&#xe904;</span>
        </Link>
        {title}
      </Heading>
    </div>
  )
}

function Heading({
  type,
  children,
  className,
}: Readonly<{ type: SizeType; children: React.ReactNode; className?: string }>) {
  if (type === 'h2') return <h2 className={className}>{children}</h2>
  if (type === 'h3') return <h3 className={className}>{children}</h3>
}
